import { ActionTextLinkCell } from "~/features/search/components/ProductResults/views/TabularView/ProductTabularViewActionCell/ProductTabularViewActionCell";
import CalculatorIcon from "~/common/mui/icons/Calculator";

export const OpenCalcAction = ({ url, ...rest }: { url?: string }) => (
  <ActionTextLinkCell href={url} invisible={!url} target={"_blank"} {...rest}>
    <CalculatorIcon  />
  </ActionTextLinkCell>
);
